<!-- FULL-PAGE LOADING OVERLAY -->
@if(userAccessForReportDashboard===false){
    <div class="fixed inset-0 flex items-center justify-center">
        <div class="bg-white p-6 rounded-lg shadow-md">
            <h2 class="text-lg font-semibold mb-4">Access Denied</h2>
            <p>You do not have permission to view this page.</p>
        </div>
    </div>
}@else{
@if(loadingReports()) {
<div role="status" aria-live="polite"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <app-loader message="Loading reports…" />
</div>
}

@if( !expandReports() && !expandLeft()) {
<app-page-header title="Reports Dashboard" [class.pointer-events-none]="loadingReports()"
    [attr.aria-busy]="loadingReports()">

    <!-- Right: Filters -->
    <div class="flex items-center gap-6">

        <!-- Department -->
        <div class="flex items-center gap-2">
            <label for="department-select" class="text-sm font-medium whitespace-nowrap">
                Department:
            </label>

            <select id="department-select" [ngModel]="selectedDepartment()" (ngModelChange)="onDepartmentChange($event)"
                [compareWith]="comparePk" [disabled]="isLoading()"
                class="w-85 px-3 py-1 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg ">
                @for (dept of departments(); track dept.pk) {
                <option [ngValue]="dept">
                    {{ dept.name }}
                </option>
                }
            </select>
        </div>

        <!-- Institution -->
        <div class="flex items-center gap-2">
            <label for="institution-select" class="text-sm font-medium whitespace-nowrap">
                Institution:
            </label>

            <select id="institution-select" [ngModel]="selectedInstitution()"
                (ngModelChange)="onInstitutionChange($event)" [compareWith]="comparePk" [disabled]="isLoading()"
                class="w-80 px-3 py-1 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg">
                @for (inst of institutions(); track inst.pk) {
                <option [ngValue]="inst">
                    {{ inst.name }}
                </option>
                }
            </select>
        </div>

    </div>

</app-page-header>
}
@if(!pageError()) {
<div [ngClass]="expandReports() ? 'fixed inset-0 z-40 p-4 m-0 w-screen h-screen max-w-none bg-main-bg' : 'max-w-[1600px] mx-auto px-6 mt-6'">
    <div class="flex gap-6 relative" [class.h-full]="expandReports()">
        <!-- LEFT PANEL -->
        @if (!expandReports()) {
        <div class="bg-white rounded-2xl shadow-sm 
                    flex flex-col h-fit transition-all duration-300"
            [class.w-[30%]]="!expandLeft() && !noReportsFound()" [class.w-full]="expandLeft() || noReportsFound()">
            <!-- LEFT HEADER -->
            <div class="flex justify-between items-center px-5 py-1" [class.border-b]="showReports()"
                [class.border-gray-300]="showReports()">
                <div class="flex items-center gap-3">
                    <button (click)="toggleReports()" [attr.aria-expanded]="showReports()"
                        aria-controls="reports-table-section" class="flex items-center justify-center
                    w-10 h-10
                    rounded-lg
                    hover:bg-blue-100
                    transition">
                        <span class="sr-only">{{ showReports() ? 'Collapse' : 'Expand' }} reports list</span>
                        @if(showReports()) {
                        <!-- Up Arrow -->
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-700"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M5.23 12.21a.75.75 0 001.06.02L10 8.77l3.71 3.46a.75.75 0 101.02-1.1l-4.25-3.97a.75.75 0 00-1.02 0L5.21 11.13a.75.75 0 00.02 1.08z"
                                clip-rule="evenodd" />
                        </svg>

                        } @else {
                        <!-- Down Arrow -->
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-700"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M14.77 7.79a.75.75 0 00-1.06-.02L10 11.23 6.29 7.77a.75.75 0 10-1.02 1.1l4.25 3.97c.3.28.77.28 1.06 0l4.25-3.97a.75.75 0 00-.02-1.08z"
                                clip-rule="evenodd" />
                        </svg>

                        }
                    </button>
                    <h2 class="text-lg font-semibold text-gray-800">
                        Reports ({{ reports().length }})
                    </h2>

                </div>
                <button (click)="toggleLeftExpand()"
                    [attr.aria-label]="expandLeft() ? 'Minimize reports panel' : 'Maximize reports panel'" class="flex items-center gap-2 px-2 py-2 
                border rounded-lg shadow-sm 
                bg-white hover:bg-blue-100 
                text-gray-700 text-sm font-medium">

                    @if (!expandLeft()) {
                    <!-- MAXIMIZE ICON -->
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">

                        <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
                    </svg>
                    } @else {
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">

                        <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            d="M10 14L3 21M14 10l7-7M3 3l7 7M21 21l-7-7" />
                    </svg>
                    }
                </button>
            </div>

            <!-- TABLE COLLAPSIBLE -->
            <div id="reports-table-section" role="region" aria-label="Reports list"
                class="transition-all duration-500 ease-in-out" [class.max-h-0]="!showReports()"
                [class.overflow-hidden]="!showReports()" [class.max-h-none]="showReports()">
                <div [class.opacity-60]="loadingReports()" class="transition-opacity duration-300">
                    @if(reports().length === 0){
                    <div class="flex flex-col items-center justify-center py-8 gap-4" role="status">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-gray-300"
                            fill="currentColor" viewBox="0 0 24 24">
                            <path d="M4 20h3V10H4v10zm6 0h3V4h-3v16zm6 0h3V7h-3v13z" />
                        </svg>
                        <div class="text-gray-500 font-semibold">
                            No Reports Found
                        </div>
                        <div class="text-gray-400 text-sm">
                            No Power BI reports available
                        </div>
                    </div>
                    } @else {
                    <div class="flex-1 overflow-y-auto">
                        <table class="w-full text-sm" aria-label="Reports">
                            <thead class="border-b border-gray-300 text-gray-600 sticky top-0 bg-white">
                                <tr>
                                    <th class="text-left py-3 px-4">Report Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (report of paginatedReports(); track report.pk) {
                                    @if(report.active) {
                                <tr (click)="selectReport(report)" (keydown.enter)="selectReport(report)"
                                    (keydown.space)="$event.preventDefault(); selectReport(report)" tabindex="0"
                                    role="row" [attr.aria-selected]="selectedReportId() === report.pk"
                                    class="cursor-pointer border-b border-gray-300 last:border-b-0 hover:bg-blue-100"
                                    [class.bg-blue-100]="selectedReportId() === report.pk"
                                    [class.border-l-4]="selectedReportId() === report.pk"
                                    [class.border-l-primary]="selectedReportId() === report.pk"
                                    [class.font-semibold]="selectedReportId() === report.pk">

                                    <td class="py-3 px-4">
                                        <div class="flex items-center gap-2 relative group">
                                            <span aria-hidden="true">📊</span>
                                            <span class="truncate">
                                                {{ report.reportName}}
                                            </span>
                                            <span role="tooltip" aria-hidden="true" class="pointer-events-none absolute -top-9 left-1/2 -translate-x-1/2
                                            whitespace-nowrap rounded bg-gray-500 border border-gray-500 px-2 py-1 text-xs text-white
                                            opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-20">
                                                View {{ report.reportName }} report
                                                <span class="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0
                                                border-l-4 border-r-4 border-t-4
                                                border-l-transparent border-r-transparent border-t-gray-500">
                                                </span>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                          }
                                }
                            </tbody>
                        </table>
                        <!--  Pagination -->
                        <nav aria-label="Reports pagination" class="px-4 py-3 bg-white-50 border-t border-gray-200 
                    flex items-center  justify-between gap-2">

                            <!-- Showing X to Y of Z -->
                            <span class="text-xs text-gray-600">
                                Showing <span class="font-semibold">{{ (currentPage() - 1) * pageSize + 1 }}</span>
                                to <span class="font-semibold">{{ currentPage() * pageSize > reports().length ?
                                    reports().length : currentPage() * pageSize }}</span>
                                of <span class="font-semibold">{{ reports().length }}</span> Reports
                            </span>

                            <div class="flex items-center gap-2">
                                <button (click)="firstPage()" [disabled]="currentPage() === 1" aria-label="First page"
                                    class="p-1 text-gray-500 hover:bg-blue-100
                   disabled:opacity-30 disabled:cursor-not-allowed">

                                    <svg aria-hidden="true" class="w-4 h-4" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M11 19l-7-7 7-7M18 19l-7-7 7-7" />
                                    </svg>
                                </button>

                                <!-- Previous -->
                                <button (click)="prevPage()" [disabled]="currentPage() === 1" aria-label="Previous page"
                                    class="p-1 text-gray-500 hover:bg-blue-100
                   disabled:opacity-30 disabled:cursor-not-allowed">

                                    <svg aria-hidden="true" class="w-4 h-4" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>

                                <!-- Page Text -->
                                <span class="text-xs text-gray-600 px-2">
                                    Page <span class="font-semibold">{{ currentPage() }}</span>
                                    of
                                    <span class="font-semibold">{{ totalPages() }}</span>
                                </span>

                                <!-- Next -->
                                <button (click)="nextPage()" [disabled]="currentPage() === totalPages()"
                                    aria-label="Next page" class="p-1 text-gray-500 hover:bg-blue-100
                   disabled:opacity-30 disabled:cursor-not-allowed">

                                    <svg aria-hidden="true" class="w-4 h-4" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>

                                <!-- Last -->
                                <button (click)="lastPage()" [disabled]="currentPage() === totalPages()"
                                    aria-label="Last page" class="p-1 text-gray-500 hover:bg-blue-100
                   disabled:opacity-30 disabled:cursor-not-allowed">

                                    <svg aria-hidden="true" class="w-4 h-4" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13 5l7 7-7 7M6 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>

                        </nav>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        <!-- RIGHT PANEL -->
        <div [class.hidden]="expandLeft() || noReportsFound() || loadingReports()" class="bg-white rounded-2xl shadow-sm 
               flex flex-col min-h-[520px] transition-all duration-300"
            [class.w-[70%]]="showReports() && !expandReports()" [class.w-full]="expandReports() || !showReports()">
            <div class="relative flex items-center justify-end px-5 py-2 border-b border-gray-300">
                <div class="absolute left-1/2 -translate-x-1/2 text-lg font-semibold text-slate-700">
                    {{ reportName }}
                </div>
                <!-- Expand Button -->
                <button (click)="toggleExpand()"
                    [attr.aria-label]="expandReports() ? 'Minimize report viewer' : 'Maximize report viewer'"
                    class="flex items-center gap-2 px-2 py-2 border rounded-lg shadow-sm bg-white hover:bg-blue-100 text-gray-700 text-sm font-medium">

                    @if (!expandReports()) {
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
                    </svg>
                    } @else {
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            d="M10 14L3 21M14 10l7-7M3 3l7 7M21 21l-7-7" />
                    </svg>
                    }
                </button>

            </div>
            @if(embeddingReport()) {
            <div class="flex-1 flex items-center justify-center">
                <app-loader message="Loading report…" />
            </div>
            }
            <div id="reportContainer" role="region" aria-label="Report viewer" class="w-full"
                [ngClass]="expandReports() ? 'h-[calc(100vh-5.5rem)]' : 'h-[580px]'"
                [class.hidden]="reportEmbedError() || embeddingReport()">
            </div>
            @if(reportEmbedError()) {
            <div role="alert" class="flex-1 flex flex-col items-center justify-center gap-4 p-8">
                <svg aria-hidden="true" class="w-12 h-12 text-red-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
                <p class="text-red-600 font-semibold text-sm text-center">{{ reportEmbedError() }}</p>
            </div>
            }
        </div>
    </div>
</div>
}
}